import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchEventTicketSales(apiKey, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/ticket_sales`,
          qs: { event: event },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventBucketSales(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/sales`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventBucketOverview(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/overview`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchPassBucketsOverview(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/pass_sales`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAttendeeAnalytics(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/attendees`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchGeoAnalytics(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/geo`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventSalesAnalytics(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/sales_by_event`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventSalesDetailAnalytics(apiKey, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/sales_detail_by_event`,
          qs: { event: event },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventPassesAnalytics(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/passes_by_event`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchPassSalesAnalytics(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/pass_sales`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchSalesAnalytics(apiKey, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/sales`,
          qs: { conditions: JSON.stringify(options) },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventTicketAnalytics(apiKey, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/tickets_by_event`,
          qs: { conditions: JSON.stringify(options) },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchRecurringPassAnalytics(apiKey, eventBucket, warningPeriod) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/recurring_pass/upcoming`,
          qs: { event_bucket: eventBucket, warning_period: warningPeriod },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchExpiredPassAnalytics(apiKey, eventBucket, expiredPassTimePeriod) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/recurring_pass/expired_passes`,
          qs: {
            event_bucket: eventBucket,
            expired_pass_time_period: expiredPassTimePeriod
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchNewSubscriptionAnalytics(
    apiKey,
    eventBucket,
    newSubscriptionTimePeriod
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/recurring_pass/new_subscriptions`,
          qs: {
            event_bucket: eventBucket,
            new_subscription_time_period: newSubscriptionTimePeriod
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/AnalyticsUtil.js